import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { HOST } from '../engine/anchors';

export function HeaderSlot({ children }: { children: React.ReactNode }) {
  const [slot, setSlot] = useState<HTMLElement | null>(null);

  useEffect(() => {
    let cancelled = false;

    const find = () => {
      const el = document.querySelector(HOST.headerSlot) as HTMLElement | null;
      const usable = el && document.contains(el) ? el : null;
      if (!cancelled) setSlot((prev) => (prev === usable ? prev : usable));
    };

    find();

    const observer = new MutationObserver(find);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-tour-slot'],
    });

    return () => {
      cancelled = true;
      observer.disconnect();
    };
  }, []);

  if (slot) return createPortal(children, slot);

  return createPortal(
    <div
      data-tour-slot-fallback=""
      style={{
        position: 'fixed',
        bottom: 60,
        left: 20,
        zIndex: 9998,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 8,
        maxWidth: 'calc(100vw - 40px)',
      }}
    >
      {children}
    </div>,
    document.body,
  );
}
